import { render, staticRenderFns } from "./bank-account-manager.vue?vue&type=template&id=51858b97&"
import script from "./bank-account-manager.vue?vue&type=script&lang=js&"
export * from "./bank-account-manager.vue?vue&type=script&lang=js&"
import style0 from "./bank-account-manager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports